module.exports = __webpack_public_path__ + "static/media/ocaml.f6efdc96.svg";